export const trim = (text: string) => {
  return text && text.trim ? text.trim() : '';
};
